export default "__VITE_ASSET__DwjmOfm7__"